export const agencyTrendData = {
    labels: [],
    datasets: [
        {
            label: 'TY Goal',
            fill: false,
            backgroundColor: 'rgba(85, 150, 217, 1)',
            borderColor: 'rgba(85, 150, 217, 0.7)',
            data: []
        },
        {
            label: 'TY Revenue',
            fill: false,
            backgroundColor: 'rgba(132, 190, 68, 1)',
            borderColor: 'rgba(132, 190, 68, 0.7)',
            data: []
        },
        {
            label: 'LY Revenue',
            fill: false,
            backgroundColor: 'rgba(200, 200, 200, 1)',
            borderColor: 'rgba(200, 200, 200, 0.7)',
            data: []
        }
    ]
};

export const lineChartOptions = {
    scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            callback: function(value, index, values) {
                    if(parseInt(value) >= 1000){
                        return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                        return '$' + value;
                    }
                }
            }
        }]
    },
    tooltips: {
        callbacks: {
            label: function(tooltipItem, data) {
                try {
                    return " " + data.datasets[tooltipItem.datasetIndex].label + ": $ " + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
                        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
                    });
                } catch(error) {
                    return tooltipItem.yLabel;
                }
            }
        }
    },
    plugins: {
        datalabels: {
            display: false
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/common/LineGraph.js